import React from "react";
import axios from "axios";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import {
  Combobox,
  ComboboxInput,
  ComboboxPopover,
  ComboboxList,
  ComboboxOption,
} from "@reach/combobox";
import "@reach/combobox/styles.css";
import "./SearchBooking.css";
import { BiCurrentLocation } from "react-icons/bi";
import { FaTrashAlt } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { useState } from "react";
import { useEffect } from "react";

const GoogleMapAuto = (props) => {
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete();

  const handleInput = (e) => {
    setValue(e.target.value);
  };
  const [showSuggest, setShowSuggest] = useState(false);
  const [clearSuggest, setClearSuggest] = useState(0);

  const handleSelect = (val) => {
    getGeocode({ address: val }).then((results) => {
      const { lat, lng } = getLatLng(results[0]);
    });
    setValue(val, false);

    clearSuggestions();

    // Get latitude and longitude via utility functions
  };
  const renderSuggestions = () => {
    console.log("dataSuggestions", data);

    const suggestions = data.map(({ place_id, description }) => (
      <div className="topLibSuggestions">
        <ComboboxOption
          key={place_id}
          value={description}
          className="comboOptionSugg"
        />
        <button className="btnAddressGQ">Address</button>
      </div>
    ));

    return (
      <>
        {suggestions}
        <li className="logo">
          <img
            src="https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/092010/google.png?itok=QoMRDjGG"
            alt="Powered by Google"
            width="150px"
            height="60px"
            style={{ objectFit: "contain" }}
          />
        </li>
      </>
    );
  };

  const locationMapClicked = () => {
    setShowSuggest(!showSuggest);

    console.log("locationMapClicked");
  };

  const suggestAddressClicked = (data, index) => {
    // setValue(data.description);
    setClearSuggest(1);
    getGeocode({ address: data.description }).then((results) => {
      const { lat, lng } = getLatLng(results[0]);
    });
    setValue(data.description, false);
  };

  useEffect(() => {
    setShowSuggest(false);
    props.setValue(value);
  }, [value]);

  const currentLocationClicked = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        console.log("positionGoogleMap", position);
        // $.get( "http://maps.googleapis.com/maps/api/geocode/json?latlng="+
        // position.coords.latitude + "," + position.coords.longitude +"&sensor=false", function(data) {
        //         console.log("positionGoogleMap",data);
        //       })
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        const address = getAddress(lat, lng);
        console.log("address9364987254", address); // outputs "New York, NY, USA"
      });
    } else {
      console.log("geolocationNotSupported");
    }
  };

  const API_KEY = "AIzaSyDxs7bBi7B_ihvy9Ct_piPfWbbaBOU5-rM";
  const getAddress = async (lat, lng) => {
    const response = await axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${API_KEY}`
    );

    console.log(
      "address9364987254",
      response?.data?.results[0]?.formatted_address
    );

    // props.defaultValue(response?.data?.results[0]?.formatted_address);
    setValue(response?.data?.results[0]?.formatted_address, false);
    return response.data.results[0].formatted_address;
  };
  // example usage:
  const crossClicked=()=>{
    setValue('');
  }

  return (
    <>
      <Combobox
        onSelect={handleSelect}
        aria-labelledby="demo"
        style={{ width: "100%" }}
        className="comboxTop"
      >
        <div className="topComboIcon">
          <ComboboxInput
            onClick={locationMapClicked}
            style={{ width: "100%", border: "1px solid #CCF4EC" }}
            value={value}
            className="mapLocationInput"
            placeholder={props.placeholder}
            onChange={handleInput}
            disabled={!ready}
          />
          {value ? (
            <FaTrashAlt className="locationCurrentIcon crossLocationInput" 
            onClick={crossClicked}
            />
          ) : (
            <BiCurrentLocation
              className="locationCurrentIcon"
              onClick={currentLocationClicked}
            />
          )}

          {showSuggest && (
            <div className="topSelectAddresses">
              {props.addressData.map((item, index) => (
                <div
                  className="topSelectAddressesInner"
                  onClick={() => suggestAddressClicked(item, index)}
                >
                  <div className="txtAddressSugges">{item.description}</div>
                  <button className="addressBtn">Address</button>
                </div>
              ))}
            </div>
          )}
        </div>
        <ComboboxPopover>
          <ComboboxList>{status === "OK" && renderSuggestions()}</ComboboxList>
        </ComboboxPopover>
      </Combobox>
    </>
  );
};

export default GoogleMapAuto;
